export default __webpack_public_path__ + "static/Plots0019-8c6695767781ebd3bae2fc5e58a6244a.jpg";